export default __webpack_public_path__ + "media/images/images/portrait/small/avatar-s-22-1f8315254f105dd1f36c43fb66c9f85e.png";